import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

const MonthStrings = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]
const StyledMonths = styled.div`
  display: flex;
  font-size: 12px;
  line-height: ${props => (props.primary ? 28 : 22)}px;
  font-weight: 500;
  text-align: center;
`
const StyledMonth = styled.div`
  flex: 1 1 22px;
  border: 1px solid #e3e3e3;
  margin-left: -1px;

  ${props =>
    props.available &&
    css`
      background-color: ${props =>
        props.primary ? props.theme.primary : props.theme.orange};
      color: ${props => props.theme.fg2};
    `}
`
const CalendarMonths = ({ available, primary }) => {
  const Months = MonthStrings.map((month, index) => (
    <StyledMonth
      key={index + 1}
      primary={primary}
      available={available && available.includes(index + 1)}
      aria-label={
        available && available.includes(index + 1)
          ? `available in ${month}`
          : `unavailable in ${month}`
      }
    >
      {month.substr(0, 1)}
    </StyledMonth>
  ))
  return (
    <StyledMonths aria-label="availability" primary={primary}>
      {Months}
    </StyledMonths>
  )
}
CalendarMonths.propTypes = {
  available: PropTypes.arrayOf(PropTypes.number),
  primary: PropTypes.bool,
}
export default CalendarMonths
